import { oddsRangeActive } from "../odds-range";
import type { OptimizerQueryState } from "../query-state";

export function getActiveAdvancedFilterCount(
  state: OptimizerQueryState,
  showWeightsFilter: boolean,
  showHidePushProps: boolean = false,
  showMinEVFilter: boolean = true,
): number {
  let count = 0;
  if (state.statTypes.length > 0) count++;
  if (state.matchups.length > 0) count++;
  if (state.minDataPoints > 0) count++;
  if (state.minLiquidity > 0) count++;
  if (state.requiredComparisonBooks.length > 0) count++;
  if (showMinEVFilter && state.minEV !== 0) count++;
  if (state.minOddsToHit > 0 || state.maxOddsToHit < 100) count++;
  if (oddsRangeActive(state)) count++;
  if (showWeightsFilter && (state.weights !== null || (state.requiredBooks && state.requiredBooks.length > 0))) count++;
  if (showHidePushProps && state.hidePushProps) count++;
  if (state.overUnder) count++;
  return count;
}
